import { CollectionMapExpressionModel } from '../../Models/CollectionMapExpressionModel';
import { ExpressionModel } from '../../Models/ExpressionModel';
import { ExpressionTypes } from '../../Models/ExpressionTypes';
import { ObjectExpressionModel } from '../../Models/ObjectExpressionModel';

type ObjectMapExpressionPatch = {
	mapIf?: ExpressionModel | undefined;
	properties?: Record<string, ExpressionModel>;
};

type CollectionMapExpressionPatch = {
	mapIf?: ExpressionModel | undefined;
	collection?: ExpressionModel | undefined;
	map?: ExpressionModel | undefined;
};

function hasPatchValue<T extends object>(patch: T, propertyName: keyof T): boolean {
	return Object.prototype.hasOwnProperty.call(patch, propertyName);
}

export function createObjectMapExpression(properties: Record<string, ExpressionModel> = {}, mapIf?: ExpressionModel): ObjectExpressionModel {
	return {
		Type: ExpressionTypes.Object,
		MapIf: mapIf,
		Properties: properties,
	} as ObjectExpressionModel;
}

export function updateObjectMapExpression(expression: ObjectExpressionModel | undefined, patch: ObjectMapExpressionPatch): ObjectExpressionModel {
	return createObjectMapExpression(
		hasPatchValue(patch, 'properties') ? (patch.properties ?? {}) : (expression?.Properties ?? {}),
		hasPatchValue(patch, 'mapIf') ? patch.mapIf : expression?.MapIf,
	);
}

export function createCollectionMapExpression(
	collection: ExpressionModel | undefined,
	map: ExpressionModel | undefined,
	mapIf?: ExpressionModel,
): CollectionMapExpressionModel {
	return {
		Type: ExpressionTypes.CollectionMap,
		MapIf: mapIf,
		Collection: collection,
		Map: map,
	} as CollectionMapExpressionModel;
}

export function updateCollectionMapExpression(
	expression: CollectionMapExpressionModel | undefined,
	patch: CollectionMapExpressionPatch,
): CollectionMapExpressionModel {
	return createCollectionMapExpression(
		hasPatchValue(patch, 'collection') ? patch.collection : expression?.Collection,
		hasPatchValue(patch, 'map') ? patch.map : expression?.Map,
		hasPatchValue(patch, 'mapIf') ? patch.mapIf : expression?.MapIf,
	);
}
